module.exports = __webpack_public_path__ + "static/media/criativos_feminino_ate_400.dc98cada.jpg";